module.exports = __webpack_public_path__ + "img/itomanman_comic10.1602eaa3.jpg";